<template>
    <modal dialog="modal-lg" class="confirm-modal view dark-top">

        <div slot="title" class="fs-large mt-4 mb-3 text-center">
            <div class="border-bottom-light pb-1">
                {{modalData.title}}
            </div>
        </div>

        <div slot="body">
            <div class="text-center px-4 pb-4" v-html="modalData.message">
            </div>
        </div>

        <div slot="footer">
            <div class="w-100 d-flex justify-content-center">
                <button :class="button.class" v-for="button in modalData.buttons" @click="triggerButton(button)">{{button.text}}</button>
            </div>
        </div>

    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Modal from './Modal'


    export default {
        data: function() {
            return {
            }
        },
        computed: {
            ...mapGetters([
                'getModalConfirmData',
                'getSelectedEvent'
            ]),
            modalData: function() {
                return this.getModalConfirmData
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'openModal'
            ]),
            close: function() {
                this.closeModal();
            },
            triggerButton: function(button){
                let vm = this;
                button.action(vm);
            }
        },
        components: {
            Modal,
        }
    }
</script>

<style lang="scss">
@import '../../assets/scss/_variables.scss';
.confirm-modal{
    .modal-dialog{
        max-width: 500px;
    }

    .modal-header{
        background-color: $lightest !important;
        color: $darkest !important;

        .close{
            display: none;
        }
    }

    .modal-body{
        height: auto;
    }
}
</style>



// WEBPACK FOOTER //
// ModalConfirm.vue?0fd4e581